"use client";

import { c as _c } from "react/compiler-runtime";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogOverlay, DialogPortal, DialogTitle } from "@/components/ui/dialog";
import { Drawer, DrawerContent, DrawerHeader } from "@/components/ui/drawer";
import { useIsMobile } from "@/hooks/use-mobile";
import type { CheckoutAddressFormData } from "@/modules/checkout/types";
const dinProBold = "font-['DINPro-Bold']";
const dinProRegular = "font-['DINPro-Regular']";
interface AddressConfirmationDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  originalAddress: CheckoutAddressFormData;
  suggestedAddress: CheckoutAddressFormData;
  onConfirm: (selectedAddress: CheckoutAddressFormData) => void;
  onBackToEdit: () => void;
}
export function AddressConfirmationDialog(t0) {
  const $ = _c(42);
  const {
    isOpen,
    onOpenChange,
    originalAddress,
    suggestedAddress,
    onConfirm,
    onBackToEdit
  } = t0;
  const isMobile = useIsMobile();
  const {
    t
  } = useTranslation();
  const [selectedAddress, setSelectedAddress] = useState("original");
  if (!originalAddress || !suggestedAddress) {
    return null;
  }
  const formatAddressForDisplay = _temp;
  let t1;
  if ($[0] !== onConfirm || $[1] !== onOpenChange || $[2] !== originalAddress || $[3] !== selectedAddress || $[4] !== suggestedAddress) {
    t1 = () => {
      const finalAddress = selectedAddress === "suggested" ? suggestedAddress : originalAddress;
      onConfirm(finalAddress);
      onOpenChange(false);
    };
    $[0] = onConfirm;
    $[1] = onOpenChange;
    $[2] = originalAddress;
    $[3] = selectedAddress;
    $[4] = suggestedAddress;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleConfirm = t1;
  let t2;
  if ($[6] !== handleConfirm || $[7] !== onBackToEdit || $[8] !== originalAddress || $[9] !== selectedAddress || $[10] !== suggestedAddress || $[11] !== t) {
    t2 = () => <div className="p-8"><div className="space-y-4 mb-8"><div className={`cursor-pointer transition-all duration-200 ${selectedAddress === "original" ? "border border-black bg-[#F0F5EE]" : "border border-[#DDDDDD] bg-white"} p-3`} onClick={() => setSelectedAddress("original")}><div className={`${dinProRegular} mb-2 block text-sm font-medium text-black`}>{t("order.addressValidation.youEntered")}</div><p className={`${dinProRegular} text-sm text-black`}>{formatAddressForDisplay(originalAddress)}</p></div><div className={`cursor-pointer transition-all duration-200 ${selectedAddress === "suggested" ? "border border-black bg-[#F0F5EE]" : "border border-[#DDDDDD] bg-white"} p-3`} onClick={() => setSelectedAddress("suggested")}><div className={`${dinProRegular} mb-2 block text-sm font-medium text-black`}>{t("order.addressValidation.weSuggest")}</div><p className={`${dinProRegular} text-sm text-black`}>{formatAddressForDisplay(suggestedAddress)}</p></div></div><div className="space-y-3"><Button onClick={handleConfirm} className={`${dinProBold} h-12 w-full rounded-none bg-black text-sm font-bold text-white hover:bg-gray-800`}>{t("order.addressValidation.confirm")}</Button><Button onClick={e => {
          e.stopPropagation();
          onBackToEdit();
        }} variant="outline" className={`${dinProBold} h-12 w-full rounded-none border-black text-sm font-bold text-black hover:bg-gray-50`}>{t("order.addressValidation.backToEdit")}</Button></div></div>;
    $[6] = handleConfirm;
    $[7] = onBackToEdit;
    $[8] = originalAddress;
    $[9] = selectedAddress;
    $[10] = suggestedAddress;
    $[11] = t;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const renderContent = t2;
  if (isMobile) {
    let t3;
    if ($[13] !== t) {
      t3 = t("order.addressValidation.verifyAddressTitle");
      $[13] = t;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    let t4;
    if ($[15] !== t3) {
      t4 = <h3 className={`${dinProBold} text-lg font-bold text-black`}>{t3}</h3>;
      $[15] = t3;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    let t5;
    if ($[17] !== onOpenChange) {
      t5 = e_0 => {
        e_0.stopPropagation();
        onOpenChange(false);
      };
      $[17] = onOpenChange;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    let t6;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <XMarkIcon className="h-5 w-5 text-gray-500" />;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    let t7;
    if ($[20] !== t5) {
      t7 = <Button variant="ghost" size="sm" onClick={t5} className="h-8 w-8 p-0 hover:bg-gray-100">{t6}</Button>;
      $[20] = t5;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    let t8;
    if ($[22] !== t4 || $[23] !== t7) {
      t8 = <DrawerHeader className="border-b bg-white p-4 text-left"><div className="flex items-center justify-between">{t4}{t7}</div></DrawerHeader>;
      $[22] = t4;
      $[23] = t7;
      $[24] = t8;
    } else {
      t8 = $[24];
    }
    let t9;
    if ($[25] !== renderContent) {
      t9 = <div className="bg-white">{renderContent()}</div>;
      $[25] = renderContent;
      $[26] = t9;
    } else {
      t9 = $[26];
    }
    let t10;
    if ($[27] !== t8 || $[28] !== t9) {
      t10 = <DrawerContent className="address-confirmation-drawer h-auto">{t8}{t9}</DrawerContent>;
      $[27] = t8;
      $[28] = t9;
      $[29] = t10;
    } else {
      t10 = $[29];
    }
    let t11;
    if ($[30] !== isOpen || $[31] !== onOpenChange || $[32] !== t10) {
      t11 = <Drawer open={isOpen} onOpenChange={onOpenChange} direction="bottom" shouldScaleBackground={false} dismissible={false}>{t10}</Drawer>;
      $[30] = isOpen;
      $[31] = onOpenChange;
      $[32] = t10;
      $[33] = t11;
    } else {
      t11 = $[33];
    }
    return t11;
  }
  let t3;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DialogOverlay className="z-[9999]" />;
    $[34] = t3;
  } else {
    t3 = $[34];
  }
  let t4;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DialogTitle className="sr-only" />;
    $[35] = t4;
  } else {
    t4 = $[35];
  }
  let t5;
  if ($[36] !== renderContent) {
    t5 = <DialogPortal>{t3}<DialogContent className="address-confirmation-dialog !w-[500px] !max-w-[500px] bg-white p-0 z-[10000]" onPointerDownOutside={_temp2} onEscapeKeyDown={_temp3} onInteractOutside={_temp4}>{t4}<div className="relative">{renderContent()}</div></DialogContent></DialogPortal>;
    $[36] = renderContent;
    $[37] = t5;
  } else {
    t5 = $[37];
  }
  let t6;
  if ($[38] !== isOpen || $[39] !== onOpenChange || $[40] !== t5) {
    t6 = <Dialog open={isOpen} onOpenChange={onOpenChange} modal={true}>{t5}</Dialog>;
    $[38] = isOpen;
    $[39] = onOpenChange;
    $[40] = t5;
    $[41] = t6;
  } else {
    t6 = $[41];
  }
  return t6;
}
function _temp4(e_3) {
  return e_3.preventDefault();
}
function _temp3(e_2) {
  return e_2.preventDefault();
}
function _temp2(e_1) {
  return e_1.preventDefault();
}
function _temp(address) {
  if (!address) {
    return "";
  }
  const parts = [address.address, address.addressDetail, address.city, address.province, address.zipCode].filter(Boolean);
  return parts.join(" ");
}